import React from "react";
import TableOfContents from "../../TableOfContents/TableOfContents.tsx";
import TocMobile from "../../ToCTelephone/TocTelephone.tsx";
// import the corresponding css file
import "./SpaCEngineering.css";
// import the separated file related to the component
import TextSpaCEngineering from "./TextSpaCEngineering.jsx";

const SpaCEngineering = () => {
  // headingData is used in the TableOfContents
  // every title (h2, h3, etc) used in the separated file of the component should be in the table
  const headingsData = [
    {
      // the level 2 is the most important level you can have (the basic one)
      level: 2,
      // the text will be displayed in the table of contents
      text: "SpaC",
      // the id should be the same as the one used in the separated file of the component else the name of the title would not be displayed as wanted
      // do not use space for the id
      id: "spac_s",
    },
    {
      level:2,
      text: "Cycle-1",
      id:"cycle-1_s"
    },
    {
      level: 3,
      text: "Design",
      id: "cycle-1-design_s",
    },
    {
      level: 3,
      text: "Build",
      id: "cycle-1-build_s",
    },
    {
      // level 3 has a specific style so the title in the TOC will be display on the right of a level 2 title
      level: 3,
      text: "Test",
      id: "cycle-1-test_s",
    },
    {
      level: 3,
      text: "Learn",
      id: "cycle-1-learn_s",
    },
    {
      level: 2,
      text:"Cycle-2",
      id:"cycle-2_s"
    },
    {
      level: 3,
      text: "Design",
      id: "cycle-2-design_s",
    },

    {
      level: 3,
      text: "Build",
      id: "cycle-2-build_s",
    },
    {
      level: 3,
      text: "Test",
      id: "cycle-2-test_s",
    },
    {
     level: 3,
     text: "Learn",
     id: "cycle-2-learn_s",
    },
    {level:2,
    text: "References",
    id:"References_s"
  }
  ]
  ;

  return (
    <>
      {/* Display the content of the page on the entire viewport */}
      <div>
        {/* divide the section in columns */}
        <div className="grid grid-cols-12 gap-4" style={{ marginLeft: "50px" }}>
          {/* section on the left (=Table of content) */}
          <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
            {/* it will stay visible on the viewport */}
            <div className="sticky top-4 scrollable">
              {/* call the Table of contents with headingData modified above */}
              <TableOfContents headings={headingsData} />
            </div>
          </div>
          {/* main content which is a separated file you call and it is displayed on the right of the section above */}
          <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
            <TextSpaCEngineering />
          </main>
          {/* display the table of content when the viewport is too small */}
          <div className="md:hidden col-span-12 order-3 TOCstyle">
            <TocMobile headings={headingsData} />
          </div>
        </div>
      </div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default SpaCEngineering;
